/*=========================================================================================
  File Name: moduleBankActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  fetchBankByPartnerId({ commit }, partnerId) {
    return new Promise((resolve, reject) => {
      axios
        .get("banks/partner/" + partnerId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchBankByPageId({ commit }, partnerId) {
    return new Promise((resolve, reject) => {
      axios
        .get("banks/page/" + partnerId)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
